import React from 'react';
import { X, Minus, Plus, Trash2 } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/use-toast';

export default function CartDrawer() {
  const { items, open, setOpen, removeItem, updateQty, subtotal, clear } = useCart();
  const { toast } = useToast();

  if (!open) return null;

  const handleCheckout = () => {
    setOpen(false);
    window.location.href = '/checkout';
  };

  return (
    <div className="fixed inset-0 z-50" style={{ background: 'rgba(42,36,24,0.55)' }} onClick={() => setOpen(false)}>
      <aside className="absolute top-0 right-0 h-full w-full max-w-[420px] flex flex-col" style={{ background: 'var(--gk-cream)' }} onClick={e => e.stopPropagation()}>
        <div className="px-6 py-4 flex items-center justify-between border-b" style={{ borderColor: '#ecdfc7' }}>
          <h3 className="font-serif text-xl font-bold" style={{ color: 'var(--gk-green-dark)' }}>Your cart</h3>
          <button onClick={() => setOpen(false)}><X size={22} /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center px-8 text-center gap-3">
            <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ background: 'var(--gk-cream-dark)' }}>
              <span className="font-serif text-2xl" style={{ color: 'var(--gk-green)' }}>0</span>
            </div>
            <p className="font-serif text-lg" style={{ color: 'var(--gk-green-dark)' }}>Your cart is empty</p>
            <p className="text-sm" style={{ color: 'var(--gk-muted)' }}>Add a jar of freshly-ground gaon spices to get started.</p>
            <button className="gk-btn-primary mt-4" onClick={() => setOpen(false)}>Continue Shopping</button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
              {items.map(i => (
                <div key={i.key} className="flex gap-3 p-3 rounded-lg" style={{ background: '#fff', border: '1px solid #ecdfc7' }}>
                  <img src={i.image} alt={i.name} className="w-16 h-16 rounded object-cover" />
                  <div className="flex-1">
                    <div className="text-sm font-semibold" style={{ color: 'var(--gk-ink)' }}>{i.name}</div>
                    <div className="text-xs" style={{ color: 'var(--gk-muted)' }}>{i.size}</div>
                    <div className="flex items-center justify-between mt-2">
                      <div className="inline-flex items-center gap-2 rounded-full px-2 py-1" style={{ border: '1px solid #ecdfc7' }}>
                        <button onClick={() => updateQty(i.key, i.qty - 1)} className="w-5 h-5 flex items-center justify-center"><Minus size={12} /></button>
                        <span className="text-sm font-medium w-4 text-center">{i.qty}</span>
                        <button onClick={() => updateQty(i.key, i.qty + 1)} className="w-5 h-5 flex items-center justify-center"><Plus size={12} /></button>
                      </div>
                      <div className="text-sm font-semibold" style={{ color: 'var(--gk-green-dark)' }}>₹{i.qty * i.price}</div>
                    </div>
                  </div>
                  <button onClick={() => removeItem(i.key)} className="self-start" aria-label="Remove"><Trash2 size={16} style={{ color: 'var(--gk-terracotta)' }} /></button>
                </div>
              ))}
            </div>
            <div className="px-6 py-4 border-t" style={{ borderColor: '#ecdfc7' }}>
              <div className="flex justify-between mb-1 text-sm" style={{ color: 'var(--gk-muted)' }}><span>Shipping</span><span>Calculated at checkout</span></div>
              <div className="flex justify-between mb-4">
                <span className="font-serif text-lg" style={{ color: 'var(--gk-green-dark)' }}>Subtotal</span>
                <span className="font-serif text-lg font-bold" style={{ color: 'var(--gk-green-dark)' }}>₹{subtotal}</span>
              </div>
              <button className="gk-btn-primary w-full justify-center" onClick={handleCheckout}>Checkout</button>
              <button className="w-full text-xs mt-3 underline" style={{ color: 'var(--gk-muted)' }} onClick={clear}>Clear cart</button>
            </div>
          </>
        )}
      </aside>
    </div>
  );
}
